exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".global-components-helpers-___SelectOrderedSubList__available-list-item___bpSMj,\n.global-components-helpers-___SelectOrderedSubList__selected-list-item___2JobQ {\n    padding: 8px;\n    display: flex;\n    font-size: 18px;\n    margin: 5px;\n    background-color: #F2F2F2;\n    border-radius: 5px;\n}\n", ""]);

// Exports
exports.locals = {
	"available-list-item": "global-components-helpers-___SelectOrderedSubList__available-list-item___bpSMj",
	"selected-list-item": "global-components-helpers-___SelectOrderedSubList__selected-list-item___2JobQ"
};